export default {
  title01: "Cuaca Saat Ini",
  title02: "24 Jam",
  title03: "RAMALAN 10 HARI",
  title04: "AQI",
  title05: "Informasi Selengkapnya",
  title06: "Terbit dan Terbenam",
  title07: "Fase Bulan",
  title08: "Bulan Purnama Berikutnya",
  title09: "Bulan Baru Berikutnya",
  title10: "Siang",
  title11: "Malam",
  title12: "Matahari Terbit",
  title13: "Matahari Terbenam",
  title14: "Bulan Terbit",
  title15: "Bulan Terbenam",
  title16: "Sumber",
  title17: "Mulai",
  title18: "Berakhir",
  title19: "Gunakan Lokasi Saat Ini",
  title20: "Cari Kota",
  title21: "Suhu Sebenarnya",
  title22: "Suhu di Tempat Teduh",
  title23: "Sekarang",
  title24: "Hari Ini",
  title25: "Minggu",
  title26: "Senin",
  title27: "Selasa",
  title28: "Rabu",
  title29: "Kamis",
  title30: "Jumat",
  title31: "Sabtu",
  title32: "Memuat...",
  title33: "Sekarang",
  title34: "Per Jam",
  title35: "Harian",
  title36: "Matahari & Bulan",
  title37: "Kualitas Udara",
  title38: "Kontak: xif550402@gmail.com",
  title39: "Perjanjian Privasi",
  title40: "Copyright @ comfortweather.com 2020 - 2025. Semua Hak Dilindungi.",
  title41: "Data disediakan oleh",
  title42: "Tinggi",
  title43: "Rendah",
  title44: "Setuju",
  title45:
    "Terima kasih telah menggunakan ComfortWeather! Untuk melindungi hak dan kepentingan hukum Anda dengan lebih baik, harap baca dengan saksama ",
  title46: "Kebijakan Privasi",
  title47: " sebelum menggunakan.",
  title48: "",
  title49: "Kontak: xyjph123@gmail.com",
  title50: "Copyright @ 24hweather.com 2020 - 2025. Semua Hak Dilindungi.",
  title51:
    "Terima kasih telah menggunakan 24hweather! Untuk melindungi hak dan kepentingan hukum Anda dengan lebih baik, harap baca dengan saksama ",
};
